import {
  format,
  formatDistanceToNow as fnsFormatDistanceToNow,
} from "date-fns";

export function formatDate(d: Date): string {
  return format(d, "MMM d");
}

export function formatDistanceToNow(d: Date): string {
  return fnsFormatDistanceToNow(d, { addSuffix: true });
}

/** Combine a YYYY-MM-DD date with HH:MM time into a local-time ISO string. */
export function combineDateTime(
  date: string | null,
  time: string | null,
): string | null {
  if (!date) return null;
  const t = time ?? "23:59";
  const [hh, mm] = t.split(":").map((s) => Number(s));
  const [yyyy, m, d] = date.split("-").map((s) => Number(s));
  const local = new Date(yyyy, (m ?? 1) - 1, d ?? 1, hh ?? 0, mm ?? 0, 0);
  return local.toISOString();
}

/** Split an ISO datetime into local YYYY-MM-DD and HH:MM strings. */
export function splitDateTime(iso: string | null): {
  date: string;
  time: string;
} {
  if (!iso) return { date: "", time: "" };
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { date: "", time: "" };
  const yyyy = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return { date: `${yyyy}-${m}-${dd}`, time: `${hh}:${mm}` };
}

/** Build the 96 quarter-hour time slots: "00:00" … "23:45". */
export function timeSlots(): string[] {
  const out: string[] = [];
  for (let h = 0; h < 24; h++) {
    for (const m of [0, 15, 30, 45]) {
      out.push(
        `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`,
      );
    }
  }
  return out;
}
